import '../assets/js/flexible.debug.js'
import Vue from 'vue'
import Vuex from 'vuex'
import * as actions from './actions'
import * as getters from './getters'
import config from './modules/config'
import userInfo from './modules/userInfo'
import questions from './modules/questions'
import common from './modules/common'
import address from './modules/address'
import lineDetail from './modules/lineDetail'

import '../assets/css/reset.css'
import '../assets/css/style.css'
import '../assets/scss/common.scss'

Vue.use(Vuex)

export default new Vuex.Store({
  actions,
  getters,
  modules: {
    common,
    config,
    userInfo,
    questions,
    address,
    lineDetail
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js